import { isDropDownResult } from '@myosh/odin-components';
import { t } from 'i18next';
import { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { VisibleFieldType } from '../../../redux/config/field-types-api';
import { useGetFiltersQuery } from '../../../redux/config/filters-api';
import WidgetCustomFilterComponent from './step-three/widget-custom-filter.component';
import WidgetGlobalFilterComponent from './step-three/widget-global-filter.componnet';
import WidgetNotBlankComponent from './step-three/widget-not-blank.component';
import { WidgetShowConfigType } from './widget-config-type';

export const WizardTabThird = ({ widgetConfigs, fieldTypeData, formValue }: WidgetShowConfigType) => {
  const [fieldsData, setFieldsData] = useState<Array<VisibleFieldType>>([]);
  const { control, watch, setValue } = useFormContext();
  const watchWidgetType = watch('type');
  const watchGlobalFilters = watch('globalFilters');

  const fieldValue = useMemo(() => {
    if (isDropDownResult(watchGlobalFilters)) {
      return watchGlobalFilters.text;
    }

    const globalFilters = widgetConfigs?.widgetData?.globalFilters;
    if (Array.isArray(globalFilters) && globalFilters.length > 0 && !watchGlobalFilters) {
      return globalFilters[0].id;
    }
    return widgetConfigs?.widgetData.field as string;
  }, [watchGlobalFilters, widgetConfigs]);

  const {
    data: filtersData,
    isFetching,
    isError,
  } = useGetFiltersQuery(
    {
      form: formValue ?? (widgetConfigs?.widgetData.forms[0] as string),
      field: fieldValue,
    },
    {
      skip: !fieldValue,
    }
  );

  useEffect(() => {
    const globalFiltersId = widgetConfigs?.widgetData?.globalFilters?.[0]?.id;

    if (globalFiltersId && !watchWidgetType) {
      const widgetFiltersValue = {
        value: globalFiltersId,
        text: globalFiltersId,
        originalData: {
          field: globalFiltersId,
          type: 'COMBOBOX',
        },
      };
      setValue('globalFilters', widgetFiltersValue);
    } else {
      setValue('globalFilters', undefined);
    }
  }, [widgetConfigs, watchWidgetType, setValue]);

  useEffect(() => {
    setFieldsData(fieldTypeData ?? []);
  }, [fieldTypeData]);

  useEffect(() => {
    setValue('globalFiltersValues', widgetConfigs?.widgetData?.globalFilters?.[0]?.values ?? []);
  }, [setValue, widgetConfigs?.widgetData?.globalFilters]);

  const resetGlobalFiltersValues = () => {
    setValue('globalFiltersValues', []);
  };

  return (
    <div className="flex flex-col justify-center gap-1.5">
      <div className="my-2">{String(t('wizardStep3Description'))}</div>
      <WidgetCustomFilterComponent
        data={fieldsData}
        visibleColumns={widgetConfigs?.widgetData.customFilterField}
        control={control}
      />
      <WidgetGlobalFilterComponent
        data={fieldsData}
        control={control}
        resetGlobalFiltersValues={resetGlobalFiltersValues}
      />
      {(watchGlobalFilters || filtersData) && (
        <WidgetNotBlankComponent
          sourceData={filtersData}
          targetData={watch('globalFiltersValues')}
          control={control}
          notBlankValue={watch('notBlank')}
          isFetching={isFetching}
          isError={isError}
        />
      )}
    </div>
  );
};
